import { useNavigate } from "react-router-dom";
export default function Footer() {
  const navigate = useNavigate();

  const services = [
    { name: "Acupuncture", path: "/service/acupuncture" },
    { name: "Chiropractic Care", path: "/service/chiropractic" },
    { name: "Massage Therapy", path: "/service/massage" },
    { name: "Physiotherapy", path: "/service/physiotherapy" },
  ];

  const connects = [
    { name: "Book an Appointment", path: "/serviceList" },
    // { name: "Become a Practitioner", path: "/about-service" },
    { name: "FAQ", path: "/faq" },
    { name: "Contact Us", path: "/contact" },
  ];

  const getToKnowUs = [
    { name: "Consent Form", path: "/consent-form" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Refund Policy", path: "/refund-&-cancellation" },
  ];

  const agreements = [
    { name: "Clinics", path: "/contractor-agreement" },
    { name: "Home and Mobile based", path: "/sole-proprietorship" },
  ];

  const footerSections = [
    { title: "Signature Treatments", items: services },
    { title: "Connect", items: connects },
    { title: "Get To Know Us", items: getToKnowUs },
    { title: "Contractor Agreement", items: agreements },
  ];

  return (
    <footer className="bg-[#0F172A] text-[#94A3B8] pt-16 pb-6 px-4 sm:px-8 md:px-10 lg:px-16">
      <div className="mx-auto">
        {/* Top Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 lg:gap-9 mb-20 md:mb-28 text-center md:text-left">
          {/* Brand */}
          <div className="md:col-span-2 flex flex-col">
            <h2 className="font-bold text-white text-2xl md:text-3xl mb-4 tracking-wider">
              Last Minute Wellness
            </h2>
            <p className="text-[#CBD5E1] text-lg md:text-xl max-w-md">
              Wellness made easy — book last-minute paramedical care in seconds.
            </p>
          </div>

          {/* Other Sections */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="font-semibold text-white text-lg mb-2 md:!mb-5">
                {section.title}
              </h4>
              <ul className="space-y-2 md:space-y-4">
                {section.items.map((item) => (
                  <li
                    key={item.name}
                    onClick={() => navigate(item.path)}
                    className="cursor-pointer hover:text-white transition-colors hover:underline hover:decoration-[#94A3B8] hover:decoration-2"
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div>
          <ul className="flex flex-row space-x-5 justify-end my-4 items-center">
            <li>
              <a
                href="https://www.linkedin.com/company/last-minute-wellness/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="flex items-center gap-2 transition"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 21 21"
                  fill="none"
                  color="#8B8D98"
                >
                  <path
                    d="M4.379 3.742a2.079 2.079 0 01-2.071 2.087A2.079 2.079 0 01.237 3.742a2.08 2.08 0 012.07-2.088A2.08 2.08 0 014.38 3.742zm.016 3.757H.22v13.36h4.175V7.5zm6.665 0H6.912v13.36h4.149v-7.013c0-3.9 5.034-4.218 5.034 0v7.013h4.165V12.4c0-6.579-7.45-6.34-9.2-3.1v-1.8z"
                    fill="currentColor"
                  ></path>
                </svg>
                <span className="sr-only">LinkedIn</span>
              </a>
            </li>

            <li>
              <a
                href="https://www.instagram.com/lastminutewellness.ca?igsh=c3Y3OWh2M2Rjdmdh"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex items-center gap-2 transition"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 21 21"
                  fill="none"
                  color="#8B8D98"
                >
                  <path
                    d="M10.5 2.296c2.675 0 2.993.01 4.05.059 2.715.123 3.983 1.412 4.107 4.107.049 1.056.058 1.374.058 4.05 0 2.675-.01 2.992-.058 4.048-.124 2.693-1.39 3.984-4.107 4.107-1.057.049-1.373.059-4.05.059-2.675 0-2.993-.01-4.049-.059-2.722-.124-3.984-1.418-4.107-4.108-.049-1.056-.059-1.373-.059-4.049 0-2.675.011-2.992.059-4.049.124-2.694 1.39-3.983 4.107-4.107 1.057-.048 1.374-.058 4.049-.058zm0-1.806c-2.721 0-3.062.012-4.13.06C2.73.717.707 2.736.54 6.38.493 7.449.48 7.789.48 10.51c0 2.722.012 3.063.06 4.132.167 3.639 2.186 5.661 5.828 5.828 1.07.049 1.41.06 4.132.06 2.721 0 3.063-.012 4.132-.06 3.635-.167 5.662-2.186 5.827-5.828.05-1.069.061-1.41.061-4.132 0-2.721-.012-3.062-.06-4.13C20.296 2.743 18.275.717 14.632.55c-1.07-.05-1.41-.06-4.132-.06zm0 4.875a5.145 5.145 0 100 10.29 5.145 5.145 0 000-10.29zm0 8.485a3.34 3.34 0 110-6.679 3.34 3.34 0 010 6.68zm5.349-9.89a1.203 1.203 0 100 2.405 1.203 1.203 0 000-2.405z"
                    fill="currentColor"
                  ></path>
                </svg>
                <span className="sr-only">Instagram</span>
              </a>
            </li>

            <li>
              <a
                href="https://www.facebook.com/people/Last-Minute-Wellness-Inc/61583170073262/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex items-center gap-2 transition"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 21 21"
                  fill="none"
                  color="#8B8D98"
                >
                  <path
                    d="M12.146 20.51v-8.14h2.73l.41-3.17h-3.14V7.17c0-.918.255-1.544 1.572-1.544h1.68V2.79c-.29-.039-1.287-.125-2.446-.125-2.42 0-4.078 1.477-4.078 4.19V9.2H6.15v3.17h2.724v8.14h3.272z"
                    fill="currentColor"
                  />
                </svg>

                <span className="sr-only">Facebook</span>
              </a>
            </li>

            <li>
              <a
                href="https://www.youtube.com/@LMWYYC"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="flex items-center gap-2 transition"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 21 21"
                  fill="none"
                  color="#8B8D98"
                >
                  <path
                    d="M4.624.654h1.202l.825 3.091.765-3.09H8.63L7.24 5.25v3.137H6.045V5.251L4.625.654zm5.506 1.982c-.934 0-1.554.618-1.554 1.532v2.796c0 1.006.525 1.53 1.554 1.53.853 0 1.525-.571 1.525-1.53V4.168c0-.893-.666-1.532-1.525-1.532zm.443 4.28c0 .311-.158.54-.444.54-.293 0-.462-.24-.462-.54V4.263c0-.312.143-.543.441-.543.326 0 .465.224.465.543v2.655zm3.95-4.233v4.33c-.13.163-.418.428-.625.428-.226 0-.282-.155-.282-.384V2.683h-1.06v4.768c0 .564.172 1.019.74 1.019.321 0 .767-.167 1.226-.712v.63h1.06V2.682h-1.06zm1.839 11.572c-.374 0-.452.263-.452.637v.55h.893v-.551c0-.367-.077-.636-.441-.636zm-3.927.033a.773.773 0 00-.21.165v3.386a.885.885 0 00.24.192c.165.083.405.089.517-.056.059-.077.088-.202.088-.375v-2.805c0-.184-.036-.322-.108-.418-.122-.16-.35-.178-.527-.089zm4.03-4.338c-2.174-.147-9.24-.147-11.41 0-2.35.16-2.628 1.58-2.645 5.317.017 3.73.292 5.156 2.644 5.316 2.171.148 9.237.148 11.411 0 2.35-.16 2.627-1.58 2.645-5.316-.018-3.73-.293-5.156-2.645-5.317zm-10.29 8.923H5.037v-6.296H3.859v-1.069h3.492v1.07H6.174v6.295zm4.046 0h-1.01v-.6c-.186.222-.38.39-.581.506-.545.312-1.292.305-1.292-.798v-4.54h1.01v4.165c0 .218.052.365.268.365.197 0 .471-.253.594-.406V13.44h1.01v5.432h.001zm3.889-1.125c0 .672-.252 1.194-.924 1.194-.37 0-.678-.135-.96-.486v.417h-1.019v-7.365h1.02v2.372c.228-.278.537-.508.898-.508.74 0 .986.626.986 1.362v3.014h-.001zm3.733-1.463h-1.932v1.025c0 .408.035.76.44.76.427 0 .452-.287.452-.76v-.377h1.04v.408c0 1.046-.45 1.68-1.514 1.68-.964 0-1.458-.702-1.458-1.68V14.9c0-.942.623-1.597 1.534-1.597.97 0 1.437.616 1.437 1.598v1.383h.001z"
                    fill="currentColor"
                  ></path>
                </svg>
                <span className="sr-only">YouTube</span>
              </a>
            </li>
          </ul>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-[#1E293B] pt-6 flex flex-col sm:flex-row justify-between items-center text-center sm:text-left gap-4">
          <p className="text-[#64748B] text-sm sm:text-base font-medium">
            &copy; {new Date().getFullYear()} Last Minute Wellness. All rights
            reserved.
          </p>
          <ul className="flex flex-wrap justify-center sm:justify-end gap-4">
            <li
              onClick={() => navigate("/terms-of-use")}
              className="cursor-pointer font-medium text-sm sm:text-base hover:text-white hover:underline hover:decoration-[#94A3B8] hover:decoration-2"
            >
              Terms of Use
            </li>
            <li
              onClick={() => navigate("/terms-of-service")}
              className="cursor-pointer font-medium text-sm sm:text-base hover:text-white hover:underline hover:decoration-[#94A3B8] hover:decoration-2"
            >
              Terms of Service
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
